import React, { Component } from 'react'  
import axios from 'axios';

class NewsletterSubscribtionWidget extends Component {
  constructor () {
    super();
    this.state = {
      email: ''
    };
  }

  updateInputValue(event) {
    this.setState({
      email: event.target.value,
      state: 'initial'
    });
  }

  getSubmitButtonMessage(state) {
    switch(state) {
      case 'loading':
        return 'loading...';
      case 'success':
        return this.props.messageSuccess || 'Danke! Bestätigung folgt per Mail';
      case 'error':
        return  this.props.messageError || "Versuch's nochmal";
      default:
        return this.props.labelSubmit || "Abonnieren";
    }
  }
  
  handleClick(e) {
    this.setState({
      state: 'loading'
    })

    if(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this.state.email) ){

      var self = this;
      axios.get('https://hooks.zapier.com/hooks/catch/4103555/n2qo7s/silent/', {
        params: {
          email: this.state.email
        }
      })
      .then((response) =>
        this.setState({
          state: 'success',
        })
      )
      .catch((error) =>
        this.setState({
          state: 'error',
        })
      );

      axios.get('https://hooks.zapier.com/hooks/catch/4103555/n983se/silent/', {
        params: {
          email: this.state.email
        }
      })

    }
    else {
      this.setState({
        state: 'error',
      })
    }
  }

  render(){

    return (
      <div className="newsletterSubscriptionWidget">
        <span>
          <input id="email"
                className={'newsletterSubscriptionWidget__email '
                  + (this.state.state == 'error' && 'newsletterSubscriptionWidget__email--error')}
                type="text"
                name="email"
                placeholder="Email"
                required
                value={this.state.email}
                onChange={event => this.updateInputValue(event)}>
          </input>
        </span>

        <span>
          <input type="submit"
                className="newsletterSubscriptionWidget__submit uppercase"
                value={this.getSubmitButtonMessage(this.state.state)}
                onClick={(event) => this.handleClick(event)}>
          </input>
        </span>

      </div>
    )
  }
}

export default NewsletterSubscribtionWidget;
